import * as Types from '../../../../__generated__/schema';

import {
  ActorTeaserAPIToken,
  ActorTeaserUser,
} from '../../../graphql/fragments/ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from '../../../graphql/fragments/ActorTeaser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RunAISchemaInferenceVariables = Types.Exact<{
  input: Types.AISchemaInferenceInput;
}>;

export type RunAISchemaInference = {
  aiSchemaInference: Pick<
    Types.AIInferenceStream,
    'streamName' | 'streamId' | 'pinned' | 'private' | 'saved' | 'createdAt' | 'parentStreamId'
  > & { createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser> };
};

export const RunAISchemaInferenceDocument = gql`
  mutation RunAISchemaInference($input: AISchemaInferenceInput!) {
    aiSchemaInference(input: $input) {
      streamName
      streamId
      pinned
      private
      saved
      createdBy {
        ...ActorTeaser
      }
      createdAt
      parentStreamId
    }
  }
  ${ActorTeaser}
`;
export type RunAISchemaInferenceMutationFn = Apollo.MutationFunction<
  RunAISchemaInference,
  RunAISchemaInferenceVariables
>;

/**
 * __useRunAISchemaInference__
 *
 * To run a mutation, you first call `useRunAISchemaInference` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunAISchemaInference` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runAiSchemaInference, { data, loading, error }] = useRunAISchemaInference({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunAISchemaInference(
  baseOptions?: Apollo.MutationHookOptions<RunAISchemaInference, RunAISchemaInferenceVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RunAISchemaInference, RunAISchemaInferenceVariables>(
    RunAISchemaInferenceDocument,
    options,
  );
}
export type RunAISchemaInferenceHookResult = ReturnType<typeof useRunAISchemaInference>;
export type RunAISchemaInferenceMutationResult = Apollo.MutationResult<RunAISchemaInference>;
export type RunAISchemaInferenceMutationOptions = Apollo.BaseMutationOptions<
  RunAISchemaInference,
  RunAISchemaInferenceVariables
>;
export function mockRunAISchemaInference({
  data,
  variables,
  errors,
}: {
  data: RunAISchemaInference;
  variables?: RunAISchemaInferenceVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: RunAISchemaInferenceDocument, variables },
    result: { data, errors },
  };
}
